import { ChartDataPoint } from "./useVitalsChart";

interface CustomDotProps {
  cx?: number;
  cy?: number;
  payload?: ChartDataPoint;
  selectedObservationId: string | undefined;
  onDotClick: (observationId: string) => void;
}

export const CustomDot = ({ cx = 0, cy = 0, payload, selectedObservationId, onDotClick }: CustomDotProps) => {
  if (!payload) return null;

  const isSelected = payload.observationId === selectedObservationId;
  const radius = isSelected ? 7 : 4;

  return (
    <circle
      cx={cx}
      cy={cy}
      r={radius}
      fill={payload.color}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        e.stopPropagation();
        onDotClick(payload.observationId);
      }}
    />
  );
};
